export const EXCMDEVICEPERIPHERAL_CREATE_RESET = 'EXCMDEVICEPERIPHERAL_CREATE_RESET'
export const EXCMDEVICEPERIPHERAL_CREATE_SET_CREATED = 'EXCMDEVICEPERIPHERAL_CREATE_SET_CREATED'
export const EXCMDEVICEPERIPHERAL_CREATE_SET_ERROR = 'EXCMDEVICEPERIPHERAL_CREATE_SET_ERROR'
export const EXCMDEVICEPERIPHERAL_CREATE_SET_VIOLATIONS = 'EXCMDEVICEPERIPHERAL_CREATE_SET_VIOLATIONS'
export const EXCMDEVICEPERIPHERAL_CREATE_TOGGLE_LOADING = 'EXCMDEVICEPERIPHERAL_CREATE_TOGGLE_LOADING'
